export const DEV_DEFAULT_VALUE = {
  isDevMode: false,
  mockApi: false,
  scannedVin: "",
  devLocale: "en",
  inspectionType: "operational",
  //KITT backend mocks
  KITTvehicleInspectionDetails: "",
};

export const DevContextActions = {
  DEV_MODE_TRUE: "DEV_MODE_TRUE",
  DEV_MODE_FALSE: "DEV_MODE_FALSE",
  MOCK_API_TRUE: "MOCK_API_TRUE",
  MOCK_API_FALSE: "MOCK_API_FALSE",
  UPDATE_SCANNED_VIN: "UPDATE_SCANNED_VIN",
  UPDATE_DEV_LOCALE: "UPDATE_DEV_LOCALE",
  UPDATE_INSPECTION_TYPE: "UPDATE_INSPECTION_TYPE",
  UPDATE_VEHICLE_INSPECTION_DETAILS: "UPDATE_VEHICLE_INSPECTION_DETAILS",
};

export const DevContextReducer = (state, action) => {
  switch (action.type) {
    case DevContextActions.DEV_MODE_FALSE:
      return { ...state, isDevMode: false };
    case DevContextActions.DEV_MODE_TRUE:
      return { ...state, isDevMode: true };
    case DevContextActions.MOCK_API_TRUE:
      return { ...state, mockApi: true };
    case DevContextActions.MOCK_API_FALSE:
      return { ...state, mockApi: false };
    case DevContextActions.UPDATE_SCANNED_VIN:
      return { ...state, scannedVin: action.value };
    case DevContextActions.UPDATE_DEV_LOCALE:
      return { ...state, devLocale: action.value };
    case DevContextActions.UPDATE_INSPECTION_TYPE:
      return { ...state, inspectionType: action.value };
    case DevContextActions.UPDATE_VEHICLE_INSPECTION_DETAILS:
      return { ...state, KITTvehicleInspectionDetails: action.value };
    default:
      return state;
  }
};
